import React from "react";
import { FaCommentMedical } from "react-icons/fa";
import useSystemVariable from "./shared/useSystemVariable";
import SystemVariablePage from "./shared/SystemVariablePage";
import { normalizeHeader, pickCell, downloadExcelTemplate } from "./shared/excelUtils";
import {
  useListComplaintsMutation, useCreateComplaintMutation,
  useUpdateComplaintMutation, useDeleteComplaintMutation,
  useBulkUpsertComplaintsMutation,
} from "../../store/systemVariablesApi";

const mapExcelRow = (row) => {
  const n = {};
  Object.keys(row || {}).forEach((k) => { n[normalizeHeader(k)] = row[k]; });
  const name = pickCell(n, ["şikayet", "sikayet", "şikayet adı", "sikayet adi", "ad", "name"]);
  return { name: name ? String(name).trim() : "" };
};

const TEMPLATE_ROWS = [
  { Şikayet: "Baş ağrısı" }, { Şikayet: "Mide bulantısı" }, { Şikayet: "Halsizlik" },
  { Şikayet: "Eklem ağrısı" }, { Şikayet: "Uyku bozukluğu" }, { Şikayet: "İştah kaybı" },
  { Şikayet: "Öksürük" }, { Şikayet: "Nefes darlığı" }, { Şikayet: "Göğüs ağrısı" }, { Şikayet: "Baş dönmesi" },
];

export default function Complaints() {
  const vm = useSystemVariable({
    listMutation: useListComplaintsMutation(),
    createMutation: useCreateComplaintMutation(),
    updateMutation: useUpdateComplaintMutation(),
    deleteMutation: useDeleteComplaintMutation(),
    bulkMutation: useBulkUpsertComplaintsMutation(),
    itemsKey: "items",
    idKey: "complaintId",
    defaultForm: { name: "" },
    itemToForm: (it) => ({ name: it?.name || "" }),
    formToPayload: (form) => ({ name: form.name }),
    entityLabel: "Şikayet",
  });

  return (
    <SystemVariablePage
      icon={<FaCommentMedical size={22} />}
      title="Şikayetler"
      subtitle={<>Excel yükleme: <b>Şikayet</b> veya <b>Şikayet Adı</b> sütunu</>}
      entityLabel="Şikayet"
      vm={vm}
      tableColumns={[{ key: "name", label: "Şikayet", bold: true }]}
      formFields={[{ key: "name", label: "Şikayet adı", required: true }]}
      importColumns={[{ key: "name", label: "Şikayet", bold: true }]}
      mapExcelRow={mapExcelRow}
      downloadTemplate={() => downloadExcelTemplate(TEMPLATE_ROWS, "Şikayetler", "sikayet_sablonu.xlsx")}
    />
  );
}
